// extracted by mini-css-extract-plugin
export default {"page":"Main_page__NwsPl","routes":"Main_routes__Q1FJf"};